import { Component, inject, OnDestroy, Signal } from '@angular/core';
import {
  DecisionOnDevelopmentConditionsCommunicationServiceForm
} from './forms/decision-on-development-conditions-communication-service.form';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../decision-on-development-conditions.routes';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { CommonModule, NgIf } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-decision-on-development-conditions-communication-service-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    ParcelsCrudComponent,
    NgxMaskDirective
  ],
  providers: [DecisionOnDevelopmentConditionsCommunicationServiceForm],
  templateUrl: './decision-on-development-conditions-communication-service-section.component.html'
})
export class DecisionOnDevelopmentConditionsCommunicationServiceSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: DecisionOnDevelopmentConditionsCommunicationServiceForm = inject(DecisionOnDevelopmentConditionsCommunicationServiceForm);

  public stages: string[] = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      const currentApp = this.application();
      if (currentApp) {
        this.store$.dispatch(
          updateParcels({
            currentApp,
            payload: this.form.toWriteModel(),
            parcels: this.form.parcelsValues,
            successFnc: (applicationId: string) => {
              this.router.navigate(
                ['../zgody'],
                {
                  relativeTo: this.route
                }
              );
            },
            failureFnc: () => {
            },
            tag: 'parcels2'
          })
        );
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../charakterystyka-inwestycji'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }

}
